(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-barbell-guide"] && !Shopify.designMode) return;
  try {
    
function initBarbellGuides(root) {
 root.querySelectorAll('[data-bb-guide]').forEach(guide => {
  if (guide.dataset.ready) return;
  guide.dataset.ready = 'true';
  const links = [...guide.querySelectorAll('[data-guide-category]')];
  const groups = [...guide.querySelectorAll('[data-guide-group]')];
  function select(category) {
   if (!links.some(link => link.dataset.guideCategory === category)) category = 'everyday';
   links.forEach(link => {
    if (link.dataset.guideCategory === category) link.setAttribute('aria-current', 'true');
    else link.removeAttribute('aria-current');
   });
   groups.forEach(group => { group.hidden = group.dataset.guideGroup !== category; });
  }
  function categoryFromHash() {
   const match = links.find(link => link.hash === window.location.hash);
   return match ? match.dataset.guideCategory : 'everyday';
  }
  select(categoryFromHash());
  links.forEach(link => link.addEventListener('click', event => {
   event.preventDefault();
   select(link.dataset.guideCategory);
   window.history.replaceState(null, '', link.hash);
  }));
  window.addEventListener('hashchange', () => select(categoryFromHash()));
 });
}
initBarbellGuides(document);
document.addEventListener('shopify:section:load', event => initBarbellGuides(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-bells-supplier-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-bells-review-carousel')) {
  customElements.define('bb-bells-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('[data-track]');
      this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
      this.pauseButton = this.querySelector('[data-pause]');
      this.progress = this.querySelector('[data-progress]');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.userPaused = false;
      this.hovered = false;
      this.onScreen = false;
      if (!this.track || !this.cards.length) return;
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1, true), options);
      this.addEventListener('mouseenter', () => { this.hovered = true; }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; }, options);
      this.track.addEventListener('pointerdown', () => this.setPaused(true), options);
      this.track.addEventListener('keydown', () => this.setPaused(true), options);
      this.track.addEventListener('scroll', () => this.updateProgress(), { ...options, passive: true });
      this.querySelectorAll('video').forEach(video => video.addEventListener('play', () => this.setPaused(true), options));
      this.pauseButton.addEventListener('click', () => this.setPaused(!this.userPaused), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.onScreen = entries[0].isIntersecting; }, { threshold: 0.1 });
        this.observer.observe(this);
      } else this.onScreen = true;
      if (this.dataset.autoplay === 'true' && !this.reducedMotion && this.cards.length > 1) {
        this.pauseButton.hidden = false;
        this.timer = setInterval(() => {
          if (this.userPaused || this.hovered || !this.onScreen || document.hidden || this.contains(document.activeElement) || this.querySelector('details[open]')) return;
          this.move(1, false);
        }, Math.max(5000, Number(this.dataset.interval) || 7000));
      }
    }
    currentIndex() {
      let nearest = 0;
      this.cards.forEach((card, index) => {
        if (Math.abs(card.offsetLeft - this.track.scrollLeft) < Math.abs(this.cards[nearest].offsetLeft - this.track.scrollLeft)) nearest = index;
      });
      return nearest;
    }
    move(direction, manual) {
      if (manual) this.setPaused(true);
      if (this.progress) this.progress.setAttribute('aria-live', manual ? 'polite' : 'off');
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      let left;
      if (direction > 0 && this.track.scrollLeft >= maxScroll - 3) left = 0;
      else if (direction < 0 && this.track.scrollLeft <= 3) left = maxScroll;
      else {
        const next = Math.max(0, Math.min(this.cards.length - 1, this.currentIndex() + direction));
        left = this.cards[next].offsetLeft;
      }
      this.track.scrollTo({ left, behavior: this.reducedMotion ? 'auto' : 'smooth' });
    }
    updateProgress() {
      if (this.progress) this.progress.textContent = this.progress.dataset.pattern.replace('__CURRENT__', String(this.currentIndex() + 1));
    }
    setPaused(paused) {
      this.userPaused = paused;
      if (this.pauseButton) this.pauseButton.textContent = paused ? this.pauseButton.dataset.resumeLabel : this.pauseButton.dataset.pauseLabel;
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const watched = new WeakSet();
    const pending = new WeakSet();
    const selector = 'product-info section-store--coupon-block';
    const watch = (host, attempt = 0) => {
      if (watched.has(host) || !host.isConnected) return;
      const root = host.shadowRoot;
      if (!root) {
        if (attempt < 100) setTimeout(() => watch(host, attempt + 1), 100);
        else pending.delete(host);
        return;
      }
      watched.add(host);
      pending.delete(host);
      const update = () => {
        let settings;
        try { settings = JSON.parse(host.dataset.settings || '{}'); } catch { return; }
        if (String(settings.coupon || '').toLowerCase() !== 'blackbear5') return;
        const banner = root.querySelector('.inner-body');
        const button = root.querySelector('.copy-button');
        if (!banner || !button || root.querySelector('[data-bb-minimum-note]')) return;
        const text = host.closest('product-info').dataset.bbMinimumNote;
        if (!text) return;
        const note = document.createElement('span');
        note.dataset.bbMinimumNote = '';
        note.textContent = text;
        note.style.cssText = 'position:absolute;font-size:10px;font-weight:400;line-height:1.1;text-align:center;color:var(--text-color);pointer-events:none;';
        const position = () => {
          const box = banner.getBoundingClientRect();
          const copy = button.getBoundingClientRect();
          const separator = root.querySelector('.separator').getBoundingClientRect();
          const available = copy.left - separator.right - 18;
          if (available >= 44) {
            Object.assign(note.style, { right: (box.right - copy.left + 8) + 'px', top: '50%', bottom: 'auto', transform: 'translateY(-50%)', width: Math.min(70, available) + 'px', whiteSpace: 'normal', fontSize: '10px' });
          } else {
            Object.assign(note.style, { right: (box.right - copy.right) + 'px', top: 'auto', bottom: '1px', transform: 'none', width: copy.width + 'px', whiteSpace: 'nowrap', fontSize: '9px' });
          }
        };
        banner.append(note);
        const sizes = new ResizeObserver(position);
        sizes.observe(banner);
        sizes.observe(button);
        position();
      };
      new MutationObserver(update).observe(root, { childList: true, subtree: true });
      update();
    };
    const scan = () => document.querySelectorAll(selector).forEach(host => {
      if (watched.has(host) || pending.has(host)) return;
      pending.add(host);
      watch(host);
    });
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
      ))) scan();
    }).observe(document.documentElement, { childList: true, subtree: true });
    customElements.whenDefined('section-store--coupon-block').then(scan);
    scan();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-hero-pro"] && !Shopify.designMode) return;
  try {
    
(() => {
  let observer;
  const update = () => {
    const source = document.querySelector('.jdgm-cards-carousel .jdgm-average-rating');
    if (!source) return false;
    const ratingText = source.querySelector('.jdgm-rating-text');
    const countText = source.querySelector('.jdgm-reviews-count');
    const rating = Number.parseFloat(ratingText?.textContent || '');
    const count = Number.parseInt((countText?.textContent || '').replace(/[^0-9]/g, ''), 10);
    if (!Number.isFinite(rating) || rating < 0 || rating > 5 || !Number.isFinite(count) || count < 1) return false;
    document.querySelectorAll('[data-bb-live-reviews]').forEach(badge => {
      const text = badge.querySelector('[class^="hero-review-text-"] p');
      if (!text) return;
      const formatted = badge.dataset.bbReviewFormat.replace('[rating]', rating.toFixed(1)).replace('[count]', String(count));
      if (text.textContent !== formatted) text.textContent = formatted;
      badge.dataset.bbReviewRating = String(rating);
      badge.dataset.bbReviewCount = String(count);
    });
    return true;
  };
  const start = () => {
    if (update()) return;
    observer?.disconnect();
    observer = new MutationObserver(() => {
      if (update()) observer.disconnect();
    });
    observer.observe(document.body, {childList: true, subtree: true, characterData: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();
})();
